export class GetCollections {
  static readonly type = '[Collections] Get collections';

  constructor(public locale: string) {}
}

export class GetMandatoryTrainingCollection {
  static readonly type = '[Collections] Get mandatory training collection';
}

export class ResetStore {
  static readonly type = '[Collections] Reset store';
}
